
import store from "@/store";

const routes = [{
    path: "/operations/stockrequest/:id",
    name: "warehousestockrequest",
    component: () => import('@/views/main/modules/Operations/StockRequest/InventoryRequestComponent'),
    beforeEnter: (to, from, next) => {
        store.dispatch('checkAccessUser', to.params.id).then((response) => {
            if (response == 'fail') {
                next('/no-access')
            } else {
                next()
            }
        }).catch(() => {

        })
    },
    meta: {
        requiresAuth: true,
        title: 'Stock Requests',
    }
}]



export default routes;
